export type AgentEngine = 'legacy' | 'react' | 'shadow';

export const ENGINE_STORAGE_KEY = 'beidou-agent-engine';

export const ENGINE_LABELS: Record<AgentEngine, string> = {
  legacy: 'Legacy',
  react: 'ReAct',
  shadow: 'Shadow',
};

export const ENGINE_HINTS: Record<AgentEngine, string> = {
  legacy: '规则 + LLM Router（默认）',
  react: 'LLM 自主多步（Phase 2）',
  shadow: 'Legacy 展示 + React 后台对比',
};

export function isAgentEngine(value: string): value is AgentEngine {
  return value === 'legacy' || value === 'react' || value === 'shadow';
}

export function loadStoredEngine(fallback: AgentEngine): AgentEngine {
  try {
    const raw = localStorage.getItem(ENGINE_STORAGE_KEY);
    if (raw && isAgentEngine(raw)) return raw;
  } catch {
    /* ignore */
  }
  return fallback;
}

export function storeEngine(engine: AgentEngine): void {
  try {
    localStorage.setItem(ENGINE_STORAGE_KEY, engine);
  } catch {
    /* ignore */
  }
}

export function normalizeEngineChoice(
  value: string,
  allowed: AgentEngine[],
  fallback: AgentEngine
): AgentEngine {
  if (isAgentEngine(value) && allowed.includes(value)) return value;
  if (allowed.includes(fallback)) return fallback;
  return allowed[0] ?? 'legacy';
}
